<template>
  <section id="precios" class="home-pricing">
    <div class="home-pricing__inner">
      <h2 class="home-pricing__title">Precios</h2>
      <div class="home-pricing__grid">
        <article class="plan-card">
          <h3 class="plan-card__name">{{ planLabels.free }}</h3>
          <p class="plan-card__price">Gratuito</p>
          <p class="plan-card__copy">Proyectos y fichas sin límite</p>
          <button type="button" class="plan-card__cta" @click="$emit('start-writing')">
            Comenzar gratis
          </button>
        </article>

        <article class="plan-card plan-card--captain">
          <h3 class="plan-card__name">
            <v-icon size="20" color="amber-darken-2" class="plan-card__crown">mdi-crown</v-icon>
            {{ planLabels.premium1 }}
          </h3>
          <p class="plan-card__badge">Próximamente</p>
          <p class="plan-card__copy">El plan de pago todavía no se contrata desde aquí.</p>
          <ul class="plan-card__details">
            <li>Más análisis del texto</li>
            <li>Más exportación y maquetación</li>
            <li>Más versiones y un comparador</li>
            <li>Planificación más completa</li>
            <li>Más pizarras</li>
            <li>Más seguimiento de la escritura</li>
          </ul>
          <router-link to="/proximamente" class="plan-card__link">Ver qué viene</router-link>
        </article>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { PLAN_UI_LABELS } from '@/constants/levels'

export default defineComponent({
  name: 'HomePricingSection',

  emits: {
    'start-writing': () => true,
  },

  data() {
    return {
      planLabels: PLAN_UI_LABELS,
    }
  },
})
</script>

<style scoped>
.home-pricing {
  scroll-margin-top: 4rem;
  padding: 4.5rem 0;
  background: linear-gradient(180deg, #f7f9fb 0%, #e8f4f8 100%);
}

.home-pricing__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.home-pricing__title {
  margin: 0 0 1.75rem;
  color: #1d3557;
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
}

.home-pricing__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
  max-width: 860px;
  margin: 0 auto;
}

.plan-card {
  min-width: 0;
  padding: 1.5rem;
  border-radius: 20px;
  background: white;
  box-shadow: 0 10px 30px rgba(29, 53, 87, 0.06);
}

.plan-card--captain {
  background: #fff8e1;
}

.plan-card__name {
  display: flex;
  align-items: center;
  margin: 0 0 0.65rem;
  color: #1d3557;
  font-size: 1.35rem;
  font-weight: 700;
}

.plan-card__crown {
  margin-right: 0.35rem;
}

.plan-card__price {
  margin: 0 0 0.5rem;
  color: #1d3557;
  font-size: 1.5rem;
  font-weight: 700;
}

.plan-card__badge {
  display: inline-block;
  margin: 0 0 0.75rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  background: #1d3557;
  color: white;
  font-size: 0.8rem;
  font-weight: 700;
}

.plan-card__copy {
  margin: 0 0 1rem;
  color: #3d4f63;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.plan-card__details {
  margin: 0 0 1.25rem;
  padding: 0;
  list-style: none;
}

.plan-card__details li {
  position: relative;
  margin: 0 0 0.45rem;
  padding-left: 1rem;
  color: #1d3557;
  line-height: 1.45;
}

.plan-card__details li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.55rem;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: #ff9f1c;
}

.plan-card__cta {
  border: 0;
  border-radius: 8px;
  padding: 0.7rem 1.1rem;
  background: linear-gradient(45deg, #1d3557, #457b9d);
  color: white;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.plan-card__link {
  color: #1d3557;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 0.15em;
}

@media (max-width: 768px) {
  .home-pricing {
    padding: 3rem 0;
  }

  .home-pricing__inner {
    padding: 0 1rem;
  }

  .home-pricing__grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .plan-card__cta {
    width: 100%;
  }
}
</style>
